import api from './api';
import _ from 'lodash';

export default {
  getQuestions() {
    return new Promise((resolve, reject) => {
      api
        .get('question', {
          params: {
            includes: 'answers'
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  getQuestion(id) {
    return new Promise((resolve, reject) => {
      api
        .get(`question/${id}`, {
          params: {
            includes: 'answers.suitabilities,parents,products,apiProducts,questionType,groups'
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  update(id, updates) {
    return new Promise((resolve, reject) => {
      api
        .put(`question/${id}`, { updates })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  addQuestion(question) {
    return new Promise((resolve, reject) => {
      api
        .post(`question`, question)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  updateAnswer(id, updates) {
    const cleanedUpdates = _.omit(updates, ['question']);
    return new Promise((resolve, reject) => {
      api
        .put(`answer/${id}`, { updates: cleanedUpdates })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  addAnswer(answer) {
    return new Promise((resolve, reject) => {
      api
        .post(`answer`, answer)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  reOrder(newOrder, groupId) {
    return new Promise((resolve, reject) => {
      api
        .put(`question/${groupId}/re-order`, { ...newOrder })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  getQuestionTypes() {
    return new Promise((resolve, reject) => {
      api
        .get('question-type', {
          params: {
            orderby: 'label'
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  attachParent(id, answerId) {
    return new Promise((resolve, reject) => {
      api
        .put(`question/${id}/attach-parent`, { answer_id: answerId })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  detachParent(id, answerId) {
    return new Promise((resolve, reject) => {
      api
        .put(`question/${id}/detach-parent`, { answer_id: answerId })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  attachProduct(id, productId) {
    return new Promise((resolve, reject) => {
      api
        .put(`question/${id}/attach-product`, { product_id: productId })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  detachProduct(id, productId) {
    return new Promise((resolve, reject) => {
      api
        .put(`question/${id}/detach-product`, { product_id: productId })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  attachGroup(id, groupId) {
    return new Promise((resolve, reject) => {
      api
        .put(`question/${id}/attach-group`, { group_id: groupId })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  detachGroup(id, groupId) {
    return new Promise((resolve, reject) => {
      api
        .put(`question/${id}/detach-group`, { group_id: groupId })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  attachApiProduct(id, productId) {
    return new Promise((resolve, reject) => {
      api
        .put(`question/${id}/attach-api-product`, { product_id: productId })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  detachApiProduct(id, productId) {
    return new Promise((resolve, reject) => {
      api
        .put(`question/${id}/detach-api-product`, { product_id: productId })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  }
};
